<template>
  <div class="banner-superior" role="status">
    <i class="pi pi-truck" aria-hidden="true" />
    <span>{{ $t('banner.shipping') }}</span>
    <i class="pi pi-gift" aria-hidden="true" />
  </div>
</template>

<script>
export default {
  name: 'BannerSuperior',
};
</script>

<style scoped>
.banner-superior {
  position: relative;
  background: var(
    --banner-strip-bg,
    linear-gradient(90deg, rgba(15, 22, 18, 0.98) 0%, rgba(26, 38, 30, 0.95) 50%, rgba(15, 22, 18, 0.98) 100%)
  );
  color: var(--banner-strip-text, rgba(244, 242, 238, 0.92));
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  width: 100%;
  min-height: 26px;
  padding: 0.28rem 0.55rem;
  z-index: 1;
  flex-wrap: wrap;
  border-bottom: 1px solid rgba(201, 169, 98, 0.2);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);
}

.banner-superior i {
  font-size: var(--nav-icon-font-size, 1.125rem);
  color: #c9a962;
}
</style>
